
import Calculator from "../../../assets/outline/Calculator.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CalculatorIcon({ className, dataTestid = "CalculatorIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Calculator data-testid={dataTestid} className={classes} {...rest} />
  );
}
